import React from "react"
import {
  Modal,
  Space,
  Typography,
  Button,
  Alert,
  message,
} from "@mimber/ui-web"
import { DeleteOutlined } from "@mimber/ui-web"
import { useDeleteRole } from "@mimber/client/mimber-organization"
import type { DeleteRoleModalProps } from "./DeleteRoleModal.types"

const { Text, Paragraph } = Typography

export const DeleteRoleModal: React.FunctionComponent<DeleteRoleModalProps> = ({
  role,
  onSuccess,
  onCancel,
  ...modalProps
}) => {
  let closeModal: (() => void) | undefined

  const mutation = useDeleteRole({
    onSuccess: () => {
      message.success("Role deleted successfully")
      closeModal?.()
      onSuccess?.()
    },
    onError: (error) => {
      message.error(`Failed to delete role: ${error.message}`)
    },
  })

  const assignmentCount =
    (role._count?.assignments ?? 0) + (role._count?.groupAssignments ?? 0)

  return (
    <Modal
      title={
        <Space>
          <DeleteOutlined style={{ color: "#ff4d4f" }} />
          Delete Role
        </Space>
      }
      footer={null}
      onCancel={onCancel}
      {...modalProps}
    >
      {(close) => {
        closeModal = close
        return (
          <Space orientation="vertical" size="large" style={{ width: "100%" }}>
            <Paragraph>
              Are you sure you want to delete the role{" "}
              <Text strong>"{role.name}"</Text>?
            </Paragraph>

            {assignmentCount > 0 && (
              <Alert
                type="warning"
                showIcon
                title="Active Assignments"
                description={`This role currently has ${assignmentCount} active assignment(s). Deleting this role will remove all assignments.`}
              />
            )}

            <Space style={{ width: "100%", justifyContent: "flex-end" }}>
              <Button onClick={close} disabled={mutation.isPending}>
                Cancel
              </Button>
              <Button
                type="primary"
                danger
                loading={mutation.isPending}
                onClick={() => mutation.mutate({ uuid: role.uuid })}
              >
                Delete Role
              </Button>
            </Space>
          </Space>
        )
      }}
    </Modal>
  )
}
